import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClap = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 498,
	height: 108,
	viewBox: "0 0 498 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M397.856 88.6987L384.489 102M397.856 102L384.489 88.6987M103.066 92.9594H86.4148M94.7414 101.243V84.6753M377.127 6L365.139 17.9289M377.127 17.929L365.139 6.00001M459.768 65.7761C458.049 68.1935 456.888 70.9506 456.552 73.9465C455.664 81.3027 459.758 88.4637 464.784 93.9613C466.968 96.4066 469.507 98.6572 472.553 99.9841C475.879 101.481 480.252 101.942 483.872 101.71C487.311 101.485 490.896 100.35 493.245 97.8178C495.769 95.0978 496.612 91.1781 496.918 87.4602C497.204 83.2008 496.757 78.7893 495.324 74.6876C493.993 70.8531 490.799 68.0858 488.054 65.2105C482.278 59.1096 473.105 56.5765 465.471 60.8526C463.068 62.0314 461.229 63.7303 459.768 65.7761ZM60.2063 20.5127C58.5878 16.9767 56.2139 13.8455 53.0222 11.4885C45.2287 5.62698 34.3662 5.51499 24.7831 7.55348C20.5549 8.40139 16.3139 9.77863 12.7898 12.339C8.8879 15.1017 5.47335 19.7304 3.34656 23.9674C1.33137 27.9954 0.256289 32.7884 1.58935 37.1117C3.02116 41.7553 6.92976 45.2954 10.9628 48.0972C15.6269 51.2324 20.9477 53.6426 26.5668 54.736C31.8145 55.7673 37.0772 53.9918 42.166 52.7946C52.9318 50.3089 61.8772 41.6341 62.0483 30.1981C62.2928 26.7085 61.5715 23.5127 60.2063 20.5127Z",
			stroke: "#ACD4FF",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1959_28657)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M274.523 16.875C276.271 16.875 277.687 15.4583 277.687 13.7109V3.16406C277.687 1.41665 276.271 0 274.523 0C272.776 0 271.359 1.41665 271.359 3.16406V13.7109C271.359 15.4583 272.776 16.875 274.523 16.875Z",
					fill: "#ACD4FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M292.505 14.9695L299.964 7.51074C301.199 6.27507 301.199 4.2718 299.964 3.03613C298.728 1.80046 296.725 1.80046 295.489 3.03613L288.03 10.4949C286.795 11.7305 286.795 13.7338 288.03 14.9695C289.266 16.2052 291.269 16.2052 292.505 14.9695Z",
					fill: "#ACD4FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M299.836 25.3125H289.289C287.542 25.3125 286.125 26.7292 286.125 28.4766C286.125 30.224 287.542 31.6406 289.289 31.6406H299.836C301.583 31.6406 303 30.224 303 28.4766C303 26.7292 301.583 25.3125 299.836 25.3125Z",
					fill: "#ACD4FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.425 37.5125L248.155 20.7826C249.935 19.0027 252.127 17.7856 254.515 17.2152C254.288 16.8973 254.034 16.5932 253.749 16.3078C250.969 13.5276 246.461 13.5276 243.681 16.3078L230.119 29.8694C231.3 32.2289 231.756 34.8673 231.425 37.5125Z",
					fill: "#002E5F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.701 33.1369C205.769 27.905 209.841 23.8784 214.88 22.7181C213.803 21.229 212.115 20.156 210.164 19.8651C206.365 19.1952 202.723 21.6731 201.952 25.4529L195.45 57.319C194.394 62.4935 195.221 67.769 197.665 72.2807C197.533 69.8733 197.704 67.4296 198.199 65.003L204.701 33.1369Z",
					fill: "#002E5F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M252.629 25.257L226.39 51.4966C224.928 52.9582 222.455 51.6634 222.823 49.6296L225.084 37.1279C225.786 33.2469 223.199 29.5346 219.315 28.8497C215.467 28.0602 211.682 30.5471 210.902 34.4018L204.4 66.2679C202.909 73.5743 205.167 81.0843 210.44 86.3571L225.595 101.513C234.245 110.162 248.268 110.162 256.918 101.513L289.918 68.512C292.698 65.7319 292.698 61.2242 289.918 58.444C287.138 55.6638 282.631 55.6638 279.85 58.444L282.833 55.4609C285.613 52.6808 285.613 48.173 282.833 45.3929C280.053 42.6127 275.546 42.6127 272.765 45.3929L277.24 40.9183C280.02 38.1381 280.02 33.6304 277.24 30.8502C274.46 28.0701 269.952 28.0701 267.172 30.8502L262.697 35.3248C265.477 32.5447 265.477 28.0372 262.697 25.2568C259.917 22.4769 255.41 22.4769 252.629 25.257Z",
					fill: "#006ADC"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1959_28657",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 108,
				height: 108,
				fill: "white",
				transform: "translate(195)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgClap);
export default ForwardRef;
